<template>
  <v-card>
    <v-card-title>
      <p class="pl-6">{{ $t("common.coach_list") }}</p>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="users"
      @click:row="showListPef"
      :loading="loading"
      sort-by="count_coach_relation"
      :sort-desc="true"
      item-key="id"
      class="elevation-1 row-pointer"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :options.sync="options"
      :server-items-length="-1"
      :items-per-page="-1"
      dense
    >
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>
      <template #item.squad="{ item }">
        <span>
          {{ item.squad?.name }}
        </span>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="500px">
      <PrcTable
        :coach="selectedCoach"
        @deleted="initialize"
        @add="editItem(selectedCoach)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { FETCH } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"
import FormMixin from "@/mixins/FormMixin.vue"

import { mapActions } from "vuex"
import PrcTable from "@/components/card/PcrTable.vue"
export default {
  name: "PefTable",
  components: { PrcTable },
  mixins: [TableMixin, FormMixin],
  data() {
    return {
      items: [],
      selectedCoach: null,
      selectedCoachId: null,
      dialog: false,
      params: { role: "COACH", archived: false },
    }
  },

  computed: {
    users() {
      return this.data
    },
    current_user() {
      return this.$store.state.user.profile
    },

    headers() {
      return [
        {
          value: "first_name",
          text: this.$tc("user.first_name", 1),
          width: "15%",
        },
        {
          value: "last_name",
          text: this.$tc("user.last_name", 1),
          width: "15%",
        },
        {
          value: "squad",
          text: this.$tc("user.squad", 1),
          width: "40%",
        },
        {
          value: "count_coach_relation",
          text: this.$tc("user.count_coach_relation", 1),
          width: "30%",
        },
      ]
    },
  },

  methods: {
    ...mapActions("user", [FETCH]),
    showListPef(item) {
      this.selectedCoachId = item.id
      this.selectedCoach = this.users.find((user) => user.id === item.id)
      this.dialog = true
    },
    editItem() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
